import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export async function validateToken(token) {
    try {
        if (!token) {
            return false;
        }

        const result = await axios.post('/validate', null, {
            headers: {
                'Authorization': token,
            }
         })

         if(result.data?.error === 'auth' || result.data?.isNeedAuth) {
            localStorage.removeItem('ggs_token');
            return false;
         }

         return result.data?.user || true;
    } catch (error) {
        return false
    }
}

export const useValidate = () => {
    const [token, setToken] = useState(() => {
        try {
            const token = localStorage.getItem('ggs_token')
            if(token) { 
                return token 
            };
            throw new Error('auth')
        } catch (error) {
            return false
        }
    });
    const [user, setUser] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('ggs_user')) || null;
        } catch (error) {
            return null;
        }
    });

    const isAuthDisabled = window?.RUNTIME_CONFIG?.IS_AUTH_DISABLED === '1'

    const navigate = useNavigate();

    useEffect(() => {
        if(isAuthDisabled) {
            setUser({ label: 'Auth Disabled', isAdmin: true });
            return;
        }
        
        async function runValidation() {
            const validatedUser = await validateToken(token);

            if(!validatedUser) {
                localStorage.removeItem('ggs_user');
                setUser(null);
                navigate('/login');
                return;
            }

            if (typeof validatedUser === 'object') {
                localStorage.setItem('ggs_user', JSON.stringify(validatedUser));
                setUser(validatedUser);
            }
        }

        runValidation();
    }, [isAuthDisabled, token])

    return [isAuthDisabled ? true : token, setToken, user]
}
